<template>
  <div class="p-3">
    <h4>Indeed — Logs</h4>
    <BForm inline class="mb-3">
      <BFormInput v-model="filters.offer_id" placeholder="Offer ID" class="mr-2" />
      <BFormInput v-model="filters.company_id" placeholder="Company ID" class="mr-2" />
      <BFormSelect v-model="filters.level" :options="levelOptions" class="mr-2" />
      <BButton variant="primary" @click="fetchLogs">Filtrer</BButton>
    </BForm>
    <BTable :items="logs" :fields="fields" small responsive striped>
      <template #cell(level)="{ item }">
        <BBadge :variant="item.level === 'error' ? 'danger' : 'secondary'">{{ item.level }}</BBadge>
      </template>
      <template #cell(job_posting_id)="{ item }">
        {{ extractJobPostingId(item) }}
      </template>
      <template #cell(details)="row">
        <BButton size="sm" variant="outline-secondary" @click="row.toggleDetails">
          {{ row.detailsShowing ? "▾" : "▸" }}
        </BButton>
      </template>
      <template #row-details="{ item }">
        <div class="p-2">
          <h6 class="mb-1">request_payload</h6>
          <pre class="payload-pre">{{ pretty(item.request_payload) }}</pre>
          <h6 class="mb-1 mt-2">response_payload</h6>
          <pre class="payload-pre">{{ pretty(item.response_payload) }}</pre>
        </div>
      </template>
    </BTable>
  </div>
</template>

<script>
import { BForm, BFormInput, BFormSelect, BButton, BTable, BBadge } from "bootstrap-vue";

export default {
  name: "IndeedLogs",
  components: { BForm, BFormInput, BFormSelect, BButton, BTable, BBadge },
  data() {
    return {
      logs: [],
      filters: { offer_id: "", company_id: "", level: "" },
      levelOptions: [
        { value: "", text: "Tous les niveaux" },
        { value: "info", text: "info" },
        { value: "error", text: "error" }
      ],
      fields: [
        "created_at",
        "direction",
        "action",
        "level",
        "http_code",
        "job_posting_id",
        "offer_id",
        "company_id",
        "source_posting_id",
        "apply_id",
        "error_message",
        { key: "details", label: "" }
      ]
    };
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    extractJobPostingId(item) {
      const p = item.request_payload || {};
      return (
        (p.job && p.job.jobId) ||
        (p.input &&
          p.input.jobPostings &&
          p.input.jobPostings[0] &&
          p.input.jobPostings[0].metadata &&
          p.input.jobPostings[0].metadata.jobPostingId) ||
        "—"
      );
    },
    pretty(value) {
      if (value === null || value === undefined) return "—";
      try {
        return JSON.stringify(value, null, 2);
      } catch (e) {
        return String(value);
      }
    },
    async fetchLogs() {
      const params = Object.fromEntries(
        Object.entries(this.filters).filter(([, v]) => v !== "")
      );
      try {
        const { data } = await this.$http.get("/enroll_admin/indeed/logs", { params });
        this.logs = data.data;
      } catch (e) {
        this.$bvToast.toast("Échec du chargement des logs", {
          title: "Indeed",
          variant: "danger",
          solid: true
        });
      }
    }
  }
};
</script>

<style scoped>
.payload-pre {
  max-height: 300px;
  overflow: auto;
  background: #f8f9fa;
  padding: 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
